import StorageKeys from "../../const/StorageKeys";
import UtilityHelper from "../utilities/UtilityHelper";
import { CompanyCodeDetails } from "../../model/app_config/AppConfigModel";
import ApiUrls from "../api/ApiUrls";
import CacheStorage from "../storage/CacheStorage";
import AppTheme from "./AppTheme";
import { CompanyUpdateDetails } from "../../model/settings/SettingsCompanyCheckUpdatesModel";

const AppConfigService = new (class AppConfigService {
  init = (data?: CompanyCodeDetails | CompanyUpdateDetails) => {
    if (data !== undefined) {
      this.save(data);
    }

    const stored: any = CacheStorage.getValue(StorageKeys.web_app_config);
    if (UtilityHelper.isNotEmpty(stored)) {
      // UPDATE URL
      ApiUrls.init();

      // UPDATE THEME
      AppTheme.init();
    }
  };

  getDefault = (key: string): string => {
    const stored: any = CacheStorage.getValue(
      StorageKeys.web_app_config_default
    );
    if (UtilityHelper.isNotEmpty(stored)) {
      const companyCodeDetails: any = JSON.parse(stored);
      return companyCodeDetails[key] ?? "";
    }
    return "";
  };

  get = (key: string): string => {
    const stored: any = CacheStorage.getValue(StorageKeys.web_app_config);
    if (UtilityHelper.isNotEmpty(stored)) {
      const companyCodeDetails: any = JSON.parse(stored);
      return companyCodeDetails[key] ?? "";
    }
    return "";
  };

  save = (data?: CompanyCodeDetails | CompanyUpdateDetails) => {
    if (data !== undefined) {
      CacheStorage.saveValue(StorageKeys.web_app_config, JSON.stringify(data));
      CacheStorage.saveValue(
        StorageKeys.web_app_config_default,
        JSON.stringify(data)
      );
      CacheStorage.saveValue(
        StorageKeys.company_default_theme,
        data.company_theme_color
      );
    }
  };

  update = (key: string, value: string): boolean => {
    const stored: any = CacheStorage.getValue(StorageKeys.web_app_config);
    if (UtilityHelper.isNotEmpty(stored)) {
      const appThemeDetail: Record<string, string> = JSON.parse(stored);
      if (key in appThemeDetail) {
        appThemeDetail[key] = value;
        CacheStorage.saveValue(
          StorageKeys.web_app_config,
          JSON.stringify(appThemeDetail)
        );
        return true;
      }
    }

    return false;
  };
})();

export default AppConfigService;
